// CDP usage events for the new search experience. Every event is prefixed with
// "NewSearch " so the analytics ingest can filter / route them as a group, and
// all property values are kept flat (string / number / boolean / null) so they
// land as queryable columns rather than inside a jsonb blob.

import analytics from '../../utils/cdpAnalytics'

const PREFIX = 'NewSearch '

function trackNewSearch(name, properties = {}) {
  analytics.track(`${PREFIX}${name}`, properties)
}

// A navigation entry was activated (route entries + Now Playing).
export function trackNavigationUse({
  source, query, label, path, action, icon,
}) {
  trackNewSearch('Navigation', {
    source,
    query: query || '',
    label: label || null,
    path: path || null,
    action: action || null,
    icon: icon || null,
  })
}

// A quick action was activated (newSet / newRepo / newSection / upgradePro ...).
export function trackQuickActionUse({
  source, query, action, label,
}) {
  trackNewSearch('Quick Action', {
    source,
    query: query || '',
    action: action || null,
    label: label || null,
  })
}

// A help / external link was activated (help-center search row or a curated
// external link such as Privacy / Terms / Cards / Support).
export function trackHelpUse({
  source, query, type, label, url,
}) {
  trackNewSearch('Help', {
    source,
    query: query || '',
    type: type || null,
    label: label || null,
    url: url || null,
  })
}

// A content result was used (open an item, open the full results page, etc.).
export function trackContentUse({
  source, query, action, itemType, itemId,
}) {
  trackNewSearch('Content', {
    source,
    query: query || '',
    action: action || null,
    itemType: itemType || null,
    itemId: itemId || null,
  })
}

// A preview-modal feature was used. `name` is the specific action (Opened,
// Open Item, Play, Queue, Edit, Navigate, Close) so each becomes its own event.
export function trackPreviewEvent(name, properties = {}) {
  trackNewSearch(`Preview ${name}`, properties)
}
